export default __webpack_public_path__ + "static/media/copy.5eb0ed73.svg";